import moment from "moment";
import { useEffect, useState } from "react";

import { DiningTypes } from "../../constants/constants";
import WindowWidth from "../../hooks/WindowWidth";

const DayButtonLogic = (view, length) => {
  const { width } = WindowWidth();
  const [widthStyle, setWidthStyle] = useState({});
  const [isPreparing, setIsPreparing] = useState(true);

  const handleStyle = () => {
    setIsPreparing(true);
    const isDinning = DiningTypes.includes(view);
    const isInRange = width > 1064 && length >= 6;

    if (isDinning && isInRange) {
      setWidthStyle({
        width: "140px",
      });
    } else if (!isDinning && isInRange) {
      const isLarge = width > 1550;

      if (isLarge) {
        setWidthStyle({
          width: "175px",
        });
      } else {
        setWidthStyle({
          width: "150px",
        });
      }
    }
    setIsPreparing(false);
  };

  useEffect(() => {
    handleStyle();
  }, []);

  return { widthStyle, isPreparing };
};

export default DayButtonLogic;
